import src from "IMAGE";
export default { src, width: 1500, height: 1500, blurWidth: 0, blurHeight: 0};
